<div class="container" fxLayout="column">
    <mat-card-title class="mat-card-heading">Test Consent</mat-card-title>
        <mat-card-title class="mat-card-title">Header: </mat-card-title> 
                <mat-card-content class="mat-card-content">{{ data.consent.data.header }}</mat-card-content>
        <mat-card-title class="mat-card-title">Content:</mat-card-title>
                <mat-card-content class="mat-card-content">{{ data.consent.data.content }}</mat-card-content>
        <mat-card-title class="mat-card-title">Footer:</mat-card-title> 
                <mat-card-content class="mat-card-content">{{ data.consent.data.footer }}</mat-card-content> 
        <mat-card-title class="mat-card-title">Created By:</mat-card-title> 
                <mat-card-content class="mat-card-content">{{ data.consent.agentName }}</mat-card-content>
        <mat-form-field class="custom-placeholder">
                <input matInput placeholder="Enter Email" [(ngModel)]="email" #emailModel="ngModel" type="email" email required>
        </mat-form-field>
    <div class="mat-button-div">
        <button class="mat-button-next" mat-button (click)="test()" [disabled]="!emailModel.valid">Test</button>
        <button class="mat-button" mat-button mat-dialog-close>Cancel</button>
    </div>

</div>

